module.exports = __webpack_public_path__ + "static/media/fighter-jet.c4f12029.svg";